import React from "react";
import classNames from "classnames/bind";
import styles from "./styles.module.scss";
import { MEAL_LOWER } from "components/StandingOrder/format";
import { TMealKey } from "components/StandingOrder/types";

const cn = classNames.bind(styles);

interface IBanner {
  /** hidden when the order deadline has passed */
  canGoBack: boolean;
  onGoBack: () => void;
}

/** "You've changed this lunch by hand..." + [Go back to standing order] (one meal). */
export const HandChangeBanner: React.FC<IBanner & { meal: TMealKey }> = ({
  meal,
  canGoBack,
  onGoBack,
}) => (
  <div
    className={cn("banner", "banner_amber")}
    data-testid={`hand-change-banner-${meal}`}
  >
    <span>
      You've changed this {MEAL_LOWER[meal]} by hand. Your standing order won't
      update it any more.
    </span>
    {canGoBack && (
      <button type="button" className={cn("back")} onClick={onGoBack}>
        Go back to standing order
      </button>
    )}
  </div>
);

/** A skipped day (day-level Go back). */
export const SkippedDayBanner: React.FC<IBanner> = ({ canGoBack, onGoBack }) => (
  <div className={cn("banner", "banner_grey")} data-testid="skipped-day-banner">
    <span>You skipped this day. Your standing order won't fill it.</span>
    {canGoBack && (
      <button type="button" className={cn("back")} onClick={onGoBack}>
        Go back to standing order
      </button>
    )}
  </div>
);

export const NeedsYouNotice: React.FC<{ text: string }> = ({ text }) => (
  <div className={cn("banner", "banner_red")} data-testid="needs-you-notice">
    {text}
  </div>
);

export default HandChangeBanner;
